<template>
    <div>
        <div class="detail-card">
            <h6>Product Delivery Location Fees</h6>
            <div v-if="(product.product_business_delivery_options) && (product.product_business_delivery_options.length != 0)">
                <p style="color:#ff0000;">You have set some general delivery settings</p>
                <p style="color:#ff0000; font-size: 12px;">You can set a different delivery fee for this product</p>
                <div v-for="delivery in product.product_business_delivery_options" :key="delivery.business_delivery_option_id" style="margin:8px 0; border-bottom: #e4e4e1 solid; padding: 0.6em 0;">
                  <b>{{delivery.business_delivery_option}}</b>
                  <span v-if="delivery.business_products_delivery_fees.length > 0">
                    <span v-for="(fee,fdex) in delivery.business_products_delivery_fees" :key="fdex">
                        <span v-if="(fee.product_delivery_product == product.product_id)"> -  &#8358;{{fee.product_delivery_fee}}
                        </span>
                    </span>
                  </span>
                  <span v-else>
                  <!-- {{delivery.business_delivery_option_price}} -->
                  </span>
                          <!-- set product delivery information -->
                          <div v-if="product_details.setProductDeliveryInformation && delivery.edit_set" class="contact_form">
                            <!-- <input v-model="delivery_option.business_delivery_option" type="text" required/> -->
                            <div class="form-group" style="margin-top:1em;">
                              <label style="font-size:12px;"> Set Delivery Amount</label>
                              <input v-model="delivery.product_delivery_fee" type="number" class="form-control" required/>
                              <p style="color:#ff0000; font-size: 12px;">Business Set Shipping Fee: &#8358;{{delivery.business_delivery_option_price}}</p>
                            </div>
                            <div class="form-group">
                              <div v-if="product_details.setProductDeliveryInformation && action_loading" class="loading-sm"></div>
                              <button :disabled="disable_btn" class="btn sp-button-02 sp-button-sm" style="" title="save" type="submit" @click="setProductDeliveryOption">Save</button>
                              <button class="btn sp-button-02 sp-button-sm" style="" title="cancel" type="submit" @click="setComponent('reset-edit','')">Cancel</button>
                            </div>
                          </div>
                          <!-- ./set product delivery information -->
                          <a v-if="sellpoint.business_id == delivery.business_delivery_option_business" style="cursor:pointer; font-size:10px;" type="btn" @click="setProductComponent('setProductDeliveryInformation',delivery)" title="Set Product Delivery Fee"><i class="fa fa-pencil"></i> Set Fee</a>
                          <span v-else style="font-size:10px; color: #063b77;">{{delivery.business_delivery_business_name}}</span>
                  </div>
            </div>
            <div v-else>
              <!-- <p>You have not set your Business Delivery Locations <a style="cursor:pointer; color:#ff0000;">Set Here</a></p> -->
              <p class="info">You have not set your Business Delivery Locations</p>
            </div>
          </div>
    </div>
</template>

<style>
 @import url("style.css");
</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
              no_data: true,
            }
        },

        methods: {
            setPage(){
                let self = this;
                localforage.getItem('xvue', function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                        self.product =  value.account.store_sellpoint.store_product;
                    }else{}
                });
           
            },
        },

        components: {},

        created: function(){
            this.setPage();
        }
    }
</script>



// WEBPACK FOOTER //
// ProductShipping.vue?32dcc91f